import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-453ee277"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "選択する", -1))
const _hoisted_2 = ["value"]
const _hoisted_3 = ["value"]
const _hoisted_4 = ["value"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "年", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: ""
}, "0", -1))
const _hoisted_7 = ["value"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "月", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: ""
}, "0", -1))
const _hoisted_10 = ["value"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "日", -1))

import ValidatableField from '@/components/ValidatableField.vue';
import { useField } from 'vee-validate';
import { computed, ref, watch } from 'vue';

interface NameObject {
  year: string;
  month: string;
  day: string;
}

interface Props {
  minYear: number;
  maxYear: number;
  name: NameObject;
  label?: string;
  modelValue?: { year: string; month: string; day: string };
  isRequired?: boolean; // Added isRequired prop similar to YearMonthSelect
}


export default /*#__PURE__*/_defineComponent({
  __name: 'YearMonthDaySelect',
  props: {
    minYear: null,
    maxYear: null,
    name: null,
    label: { default: '' },
    modelValue: { default: () => ({ year: '', month: '', day: '' }) },
    isRequired: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: { year: string; month: string; day: string }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { minYear: number, maxYear: number, name: NameObject, label: string, modelValue: { year: string; month: string; day: string }, isRequired: boolean }





const internalValue = ref({
  year: props.modelValue?.year || '',
  month: props.modelValue?.month || '',
  day: props.modelValue?.day || ''
});

const daysInMonth = ref(31);

/**
 * Calculate the number of days in the selected month and year
 * Updates the daysInMonth ref and adjusts the day value if needed
 */
function updateDaysInMonth() {
  const year = Number(internalValue.value.year) || new Date().getFullYear();
  const month = Number(internalValue.value.month);
  
  if (!month) {
    daysInMonth.value = 31;
    return;
  }
  
  // Get the last day of the month
  const lastDay = new Date(year, month, 0).getDate();
  daysInMonth.value = lastDay;
  
  // If the current day is greater than the days in the new month, reset it
  if (Number(internalValue.value.day) > lastDay) {
    internalValue.value.day = '';
    dayField.value.value = '';
  }
}

/**
 * Watch for changes in the modelValue prop
 * Updates internal values and recalculates days in month
 */
watch(() => props.modelValue, (newValue) => {  
  if (newValue) {
    internalValue.value = {
      year: newValue.year || '',
      month: newValue.month || '',
      day: newValue.day || ''
    };
    updateDaysInMonth();
  }
}, { deep: true });

/**
 * Emit updated values to parent component
 */
function emitUpdate() {
  emit('update:modelValue', {
    year: internalValue.value.year,
    month: internalValue.value.month,
    day: internalValue.value.day
  });
}

/**
 * Computed validation rules for year field
 * Required if:
 * 1. isRequired prop is true, or
 * 2. month or day has a value (ensuring all fields are filled if any one is)
 */
const yearRules = computed(() => {
  return 'required';
});

const monthRules = computed(() => {
  return 'required';
});

const dayRules = computed(() => {
  return 'required';
});

/**
 * Initialize form fields with validation rules
 */
const yearField = useField(props.name.year, yearRules, {
  label: `${props.label}年`,
  initialValue: internalValue.value.year,
});

const monthField = useField(props.name.month, monthRules, {
  label: `${props.label}月`,
  initialValue: internalValue.value.month,
});

const dayField = useField(props.name.day, dayRules, {
  label: `${props.label}日`,
  initialValue: internalValue.value.day,
});

/**
 * Watch for changes in year field and update internal value
 */
watch(() => yearField.value.value, (newVal) => {
  internalValue.value.year = String(newVal);
  updateDaysInMonth();
  emitUpdate();
}, {immediate: true});

/**
 * Watch for changes in month field and update internal value
 */
watch(() => monthField.value.value, (newVal) => {
  internalValue.value.month = String(newVal);
  updateDaysInMonth();
  emitUpdate();
}, {immediate: true});

/**
 * Watch for changes in day field and update internal value
 */
watch(() => dayField.value.value, (newVal) => {
  internalValue.value.day = String(newVal);
  emitUpdate();
}, {immediate: true});

// Update days in month on component mount
updateDaysInMonth();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ValidatableField, {
      as: "select",
      rules: _unref(yearRules),
      class: _normalizeClass(['p-recommend-form__select', {'--has-value': !!_unref(yearField).value.value}]),
      id: __props.name.year,
      name: __props.name.year,
      label: `${__props.label}年`,
      onChange: updateDaysInMonth
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        (_unref(yearField).value.value && Number(_unref(yearField).value.value) < __props.minYear)
          ? (_openBlock(), _createElementBlock("option", {
              key: 0,
              value: Number(_unref(yearField).value.value),
              selected: "",
              disabled: ""
            }, _toDisplayString(_unref(yearField).value), 9, _hoisted_2))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((__props.maxYear - __props.minYear + 1), (i) => {
          return (_openBlock(), _createElementBlock("option", {
            key: i,
            value: __props.minYear + i - 1
          }, _toDisplayString(__props.minYear + i - 1), 9, _hoisted_3))
        }), 128)),
        (_unref(yearField).value.value && Number(_unref(yearField).value.value) > __props.maxYear)
          ? (_openBlock(), _createElementBlock("option", {
              key: 1,
              value: Number(_unref(yearField).value.value),
              selected: "",
              disabled: ""
            }, _toDisplayString(_unref(yearField).value), 9, _hoisted_4))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["rules", "class", "id", "name", "label"]),
    _hoisted_5,
    _createVNode(ValidatableField, {
      as: "select",
      rules: _unref(monthRules),
      class: _normalizeClass(['p-recommend-form__select', {'--has-value': !!_unref(monthField).value.value}]),
      id: __props.name.month,
      name: __props.name.month,
      label: `${__props.label}月`,
      onChange: updateDaysInMonth
    }, {
      default: _withCtx(() => [
        _hoisted_6,
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (i) => {
          return _createElementVNode("option", {
            key: i,
            value: i
          }, _toDisplayString(i), 9, _hoisted_7)
        }), 64))
      ]),
      _: 1
    }, 8, ["rules", "class", "id", "name", "label"]),
    _hoisted_8,
    _createVNode(ValidatableField, {
      as: "select",
      rules: _unref(dayRules),
      class: _normalizeClass(['p-recommend-form__select', {'--has-value': !!_unref(dayField).value.value}]),
      id: __props.name.day,
      name: __props.name.day,
      label: `${__props.label}日`
    }, {
      default: _withCtx(() => [
        _hoisted_9,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(daysInMonth.value, (i) => {
          return (_openBlock(), _createElementBlock("option", {
            key: i,
            value: i
          }, _toDisplayString(i), 9, _hoisted_10))
        }), 128))
      ]),
      _: 1
    }, 8, ["rules", "class", "id", "name", "label"]),
    _hoisted_11
  ], 64))
}
}

})